export default __webpack_public_path__ + "1c85bac9ab84644ea8329583b9238dcd.png";